/***
 * checkIsAllApproversApproved returns true if all approvers are approved
 * @param milestone: milestone
 */
export const checkIsAllApproversApproved = ({
  approvers,
  projectLeaderApprovers,
}) => {
  const hasUnapprovedApprovers = approvers?.some(
    ({ isDeleted, isNotApplicable, assignedUsers }) =>
      !isDeleted &&
      !isNotApplicable &&
      assignedUsers?.some((user) => !user.approved)
  );

  if (hasUnapprovedApprovers) return false;

  const hasUnapprovedProjectLeaders = projectLeaderApprovers?.some(
    ({ isNotApplicable, assignedUser }) =>
      !isNotApplicable && !assignedUser?.approved
  );

  return !hasUnapprovedProjectLeaders;
};
